<ion-row class="cost-info-row" *ngIf="showStromstotte; else loadingTemplate">
  <ion-col class="box-col-stromstotte">
    <div *ngIf="hasHistoricalCalculation">
      <p>
        Beregnet strømstøtte for
        <span>{{ currentDayMonth }}</span>
      </p>
      <p>
        Ikke tilgjengelig<ion-icon
          name="help-circle-outline"
          (click)="expandHistoricalStotte()"
        ></ion-icon>
      </p>
    </div>
    <div
      *ngIf="
        recievesStromstotte && !hasFetchingError && !hasHistoricalCalculation
      "
    >
      <p>
        {{ isCurrentMonth ? 'Foreløpig beregnet' : 'Beregnet' }} strømstøtte den
        <span
          >{{ currentDayMonth
          }}<ion-icon
            name="help-circle-outline"
            (click)="expandTooltip()"
          ></ion-icon
        ></span>
      </p>
      <p class="nokkeltall">{{ toCommaNumber(-estimatedStromstotte) }} kr</p>
    </div>
    <div
      *ngIf="
        !recievesStromstotte && !hasFetchingError && !hasHistoricalCalculation
      "
    >
      <p>
        {{ isCurrentMonth ? 'Foreløpig beregnet' : 'Beregnet' }} strømstøtte den
        <span
          >{{ currentDayMonth
          }}<ion-icon
            name="help-circle-outline"
            (click)="expandTooltip()"
          ></ion-icon
        ></span>
      </p>
      <p>Det ligger ikke an til å bli støtte for denne dagen</p>
    </div>
    <div *ngIf="hasFetchingError && !hasHistoricalCalculation">
      <p>Det oppstod en feil ved henting av strømstøtte</p>
    </div>
  </ion-col>
</ion-row>

<ng-template #loadingTemplate>
  <div class="loadingContainer" *ngIf="showLoader">
    <ion-spinner name="dots"></ion-spinner>
  </div>
</ng-template>
